export const handleActualTitle = (t, item) => {
    var text = t(`commons:website.titles_html.${item}`);
    text ? document.title = t(`commons:website.titles_html.${item}`) :
        document.title = t(`commons:website.titles_html.centribot`)
}